const TYPING_INDICATOR_ID = 'aws-chatkit-typing-indicator';
const TYPING_TIMEOUT_MS = 3000;

let _typingTimer = null;

const _scrollToBottom = (container) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (messages) messages.scrollTop = messages.scrollHeight;
};

export const clearTypingIndicator = (container) => {
  clearTimeout(_typingTimer);
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return;
  const indicator = messages.querySelector(`#${TYPING_INDICATOR_ID}`);
  if (indicator) indicator.remove();
};

export const showTypingIndicator = (container, displayName) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return;

  let indicator = messages.querySelector(`#${TYPING_INDICATOR_ID}`);
  if (!indicator) {
    indicator = document.createElement('div');
    indicator.id = TYPING_INDICATOR_ID;
    indicator.className = 'aws-chatkit-typing';
    messages.appendChild(indicator);
  }
  indicator.textContent = `${displayName} is typing...`;
  _scrollToBottom(container);

  clearTimeout(_typingTimer);
  _typingTimer = setTimeout(() => clearTypingIndicator(container), TYPING_TIMEOUT_MS);
};

export const appendEvent = (container, text) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return null;

  const eventContainer = document.createElement('div');
  eventContainer.className = 'aws-chatkit-event';
  eventContainer.textContent = text;
  messages.appendChild(eventContainer);
  _scrollToBottom(container);
  return eventContainer;
};

const _buildSender = (senderName) => {
  const sender = document.createElement('div');
  sender.className = 'aws-chatkit-message-sender';
  sender.textContent = senderName;
  return sender;
};

const _buildMessageBubble = (text) => {
  const messageBubble = document.createElement('div');
  messageBubble.className = 'aws-chatkit-bubble';
  messageBubble.textContent = text;
  return messageBubble;
};

const _markMessagePending = (messageGroup, pendingMessageId) => {
  messageGroup.dataset.pendingMessageId = pendingMessageId;
  messageGroup.classList.add('pending');
};

export const unmarkMessagePending = (messageGroup) => {
  messageGroup.classList.remove('pending');
  messageGroup.dataset.pendingMessageId = null;
};

export const appendMessage = (container, type, text, senderName, pendingMessageId = null) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return null;

  const messageGroup = document.createElement('div');
  messageGroup.className = `aws-chatkit-message-group ${type}`;

  if (pendingMessageId) _markMessagePending(messageGroup, pendingMessageId);

  if (senderName) {
    const lastMessageGroup = messages.querySelector('.aws-chatkit-message-group:last-child');
    const isSameSender = lastMessageGroup && lastMessageGroup.classList.contains(type);
    if (!isSameSender) {
      const sender = _buildSender(senderName);
      messageGroup.appendChild(sender);
    }
  }

  const messageBubble = _buildMessageBubble(text);
  messageGroup.appendChild(messageBubble);

  messages.appendChild(messageGroup);
  _scrollToBottom(container);
  return messageGroup;
};
